export interface Lookup {
    id: number;
    name: string;
}

export interface BokParamType {
    id: number;
    name: string;
}

export interface AccItemParamValue {
    paramType: number;
    param: string;
}

export interface AccItemParamRowDTO {
    brand: number;
    brandName: string;
    depot: number;
    depotName: string;
    statGroup: number;
    statGroupName: string;
    divItem: number;
    divItemName: string;
    values: AccItemParamValue[];
}

export interface SaveAccItemParamRow {
    originalBrand: number;
    originalDepot: number;
    originalStatGroup: number;
    originalDivItem: number;
    brand: number;
    depot: number;
    statGroup: number;
    divItem: number;
    values: AccItemParamValue[];
}

export default interface AccItemParamRow {
    brand: number;
    brandName: string;
    depot: number;
    depotName: string;
    statGroup: number;
    statGroupName: string;
    divItem: number;
    divItemName: string;
    inEdit: boolean;
    deleting: boolean;
    isNew: boolean;
    [key: string]: any;
}

export const accItemParamRowDefaultProps: AccItemParamRow = {
    brand: 0,
    brandName: "",
    depot: 0,
    depotName: "",
    statGroup: 0,
    statGroupName: "",
    divItem: 0,
    divItemName: "",
    inEdit: false,
    deleting: false,
    isNew: false,
};
